module.exports = __webpack_public_path__ + "static/media/14.751840b7.wav";